class CollectionConcernFilters extends HTMLElement {
  async connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    const row = this.querySelector('ul');
    const thumb = this.querySelector('.collection-concern-filters__scroll-thumb');
    this.updateOverflow = () => {
      const maximum = row.scrollWidth - row.clientWidth;
      this.toggleAttribute('data-overflow', maximum > 1);
      this.toggleAttribute('data-scrollable-right', maximum - row.scrollLeft > 1);
      if (thumb) {
        const width = Math.max(8, row.clientWidth / row.scrollWidth * 100);
        thumb.style.width = `${width}%`;
        thumb.style.left = `${maximum > 0 ? row.scrollLeft / maximum * (100 - width) : 0}%`;
      }
    };
    let drag;
    let suppressClick = false;
    row.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      suppressClick = false;
      if (row.scrollWidth <= row.clientWidth) return;
      drag = { id: event.pointerId, x: event.clientX, scroll: row.scrollLeft, active: false };
    }, { signal });
    window.addEventListener('pointermove', event => {
      if (!drag || event.pointerId !== drag.id) return;
      const distance = event.clientX - drag.x;
      if (!drag.active && Math.abs(distance) < 6) return;
      if (!drag.active) {
        drag.active = true;
        suppressClick = true;
        row.setPointerCapture(event.pointerId);
        this.setAttribute('data-dragging', '');
      }
      event.preventDefault();
      row.scrollLeft = drag.scroll - distance;
    }, { signal });
    const finishDrag = event => {
      if (!drag || event.pointerId !== drag.id) return;
      drag = null;
      this.removeAttribute('data-dragging');
    };
    window.addEventListener('pointerup', finishDrag, { signal });
    window.addEventListener('pointercancel', finishDrag, { signal });
    row.addEventListener('lostpointercapture', finishDrag, { signal });
    row.addEventListener('dragstart', event => event.preventDefault(), { signal });
    row.addEventListener('click', event => {
      if (!suppressClick || event.detail === 0) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, { capture: true, signal });
    row.addEventListener('scroll', this.updateOverflow, { passive: true, signal });
    this.resizeObserver = new ResizeObserver(this.updateOverflow);
    this.resizeObserver.observe(row);
    this.updateOverflow();
    const links = [...this.querySelectorAll('li[data-filter-tag] a')];
    const endpoint = new URL(window.location.href);
    endpoint.searchParams.delete('sections');
    endpoint.searchParams.set('section_id', 'collection-filter-data');
    endpoint.searchParams.set('page', '1');
    try {
      const tags = new Set();
      let pages = 1;
      for (let page = 1; page <= pages; page++) {
        endpoint.searchParams.set('page', page);
        const response = await fetch(endpoint, { signal });
        if (!response.ok) throw new Error('Unable to load collection filters');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const data = JSON.parse(doc.querySelector('[data-collection-filter-data]').textContent);
        pages = data.pages;
        data.tags.forEach(tag => tags.add(tag));
      }
      for (const link of links) {
        const selected = link.hasAttribute('aria-current');
        const item = link.closest('li');
        item.hidden = !selected && !tags.has(item.dataset.filterTag);
        const destination = new URL(link.href);
        destination.search = window.location.search;
        destination.searchParams.delete('page');
        destination.searchParams.delete('section_id');
        destination.searchParams.delete('sections');
        link.href = destination;
      }
      this.hidden = ![...this.querySelectorAll('li')].some(item => !item.hidden);
      this.updateOverflow();
      this.dataset.ready = 'true';
    } catch (error) {
      if (error.name === 'AbortError') return;
      // Keep the server-rendered tag links if the supplementary request fails.
      this.dataset.ready = 'error';
    }
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.resizeObserver?.disconnect();
  }
}
customElements.define('collection-concern-filters', CollectionConcernFilters);
